export enum LogLevel {
    Off = 0,
    Custom,
    Error,
    Warning,
    Info,
    Debug,
}
